import { getAvatarUrl } from '@/utils/bridge.js';
import { loginSecret } from '@/api/modules/migu';
import { CarrierType } from '@/model/CarrierType';
import { newLogin } from '@/api/modules/user';
import Router from '@/router';
const user = {
    namespaced: true,
    state: () => {
        return {
            // 头像
            avatar: ''
        };
    },
    mutations: {
        SET_AVATAR: (state, data) => {
            state.avatar = data;
        }
    },
    actions: {
        // 获取用户头像
        getAvatar({ commit }) {
            return new Promise((resolve, reject) => {
                getAvatarUrl()
                    .then((data) => {
                    const avatarUrl = JSON.parse(data).avatarUrl ? JSON.parse(data).avatarUrl : '';
                    commit('SET_AVATAR', avatarUrl);
                    resolve(avatarUrl);
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        },
        getUserToken({ commit, rootState, dispatch }, { phone, type, isCommit = true }) {
            return new Promise((resolve, reject) => {
                if (type === CarrierType.MIGU) {
                    loginSecret({ loginType: 3, mobile: phone, channelCode: rootState.ringtone.channelCodeH })
                        .then((res) => {
                        dispatch('ringtone/handleActionApi', {
                            isp: CarrierType.ENUM[CarrierType.MIGU],
                            token: res.data.token,
                            phone,
                            action: '23',
                            interfaceName: 'mobile/login/secret',
                            resCode: res.code,
                            resMessage: JSON.stringify(res)
                        }, { root: true });
                        dispatch('ringtone/checkMobileTrack', {
                            type: '23',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.MIGU
                        }, { root: true });
                        if (isCommit) {
                            commit('app/SET_USERINFO', { phone, TOKEN: res.data.token }, { root: true });
                        }
                        resolve({ ...res.data, phone });
                    })
                        .catch((err) => {
                        reject(err);
                    });
                }
                else {
                    newLogin({ phone, picd: Router.currentRoute.query.picd })
                        .then((res) => {
                        if (isCommit) {
                            commit('app/SET_USERINFO', { phone, TOKEN: res.data.token }, { root: true });
                        }
                        resolve(res.data);
                    })
                        .catch((err) => {
                        reject(err);
                    });
                }
            });
        }
    }
};
export default user;
